export enum LocalChangeType {
  Status = 'status',
  Check = 'check',
  Rate = 'rate',
  Evidence = 'evidence',
  Telemetric = 'telemetric'
}
